module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('em', [_c('strong', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Excursuses#fm-1"
    }
  }, [_c('em', [_vm._v("List of Excursuses")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Preface#fm-2"
    }
  }, [_c('em', [_vm._v("Editor’s Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Author#fm-3"
    }
  }, [_c('em', [_vm._v("Author’s Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Abbreviations#fm-4"
    }
  }, [_c('em', [_vm._v("List of Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Bibliography#fm-5"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#fm-6"
    }
  }, [_c('strong', [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec-1"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('strong', [_vm._v("I."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Authorship")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec2-1"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("A Brief History of the Authorship Question")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec2-2"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Arguments against Pauline Authorship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec2-3"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Evaluation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-t"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec-2"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_c('strong', [_vm._v("II."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Recipients")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec2-4"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Whom Does the Letter Address?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec2-5"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Ephesus as Regional Hub")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec2-6"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Magic, Worship, Power")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-t"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec-3"
    }
  }, [_c('span', {
    staticClass: "toc11"
  }, [_c('strong', [_vm._v("III."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Setting and Date")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec-4"
    }
  }, [_c('span', {
    staticClass: "toc4"
  }, [_c('strong', [_vm._v("IV."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Ephesians and Colossians")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec-5"
    }
  }, [_c('span', {
    staticClass: "toc5"
  }, [_c('strong', [_vm._v("V."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Themes")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec2-7"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Union with Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec2-8"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Supremacy of Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec2-9"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Salvation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec2-10"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Jew and Gentile Reconciliation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec2-11"
    }
  }, [_vm._v("E."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec2-12"
    }
  }, [_vm._v("F."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Spiritual Warfare")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec2-13"
    }
  }, [_vm._v("G."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The "), _c('em', [_vm._v("Missio Dei")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec2-14"
    }
  }, [_vm._v("H."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Centrality of the Glory of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec-t"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Introduction#sec-6"
    }
  }, [_c('span', {
    staticClass: "toc12"
  }, [_c('strong', [_vm._v("VI."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Structure")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary01#ch-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("COMMENTARY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary01#sec-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('strong', [_vm._v("I."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Salutation (1:1–2)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Commentary02#sec-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_c('strong', [_vm._v("II."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Doxology (1:3–14)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary03#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc11"
  }, [_c('strong', [_vm._v("III."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Thanksgiving Prayer (1:15–23)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Commentary04#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc4"
  }, [_c('strong', [_vm._v("IV."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Raised with Christ (2:1–10)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Commentary05#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc5"
  }, [_c('strong', [_vm._v("V."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Joined Together in Christ (2:11–22)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Commentary06#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc11"
  }, [_c('strong', [_vm._v("VI."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Paul, Prisoner of Christ (3:1–13)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Commentary07#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc12"
  }, [_c('strong', [_vm._v("VII."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Prayer for Spiritual Power (3:14–21)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Commentary08#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VIII."), _c('span', {
    staticClass: "toc-1"
  }, [_vm._v("One Body (4:1–16)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Commentary09#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc11"
  }, [_c('strong', [_vm._v("IX."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("New-for-Old Replacement (4:17–32)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Commentary10#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc10"
  }, [_c('strong', [_vm._v("X."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Walking in the Way of Love (5:1–21)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Commentary11#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc11"
  }, [_c('strong', [_vm._v("XI."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Household Code (5:22–6:9)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Commentary12#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc12"
  }, [_c('strong', [_vm._v("XII."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Spiritual Warfare (6:10–17)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Commentary13#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("XIII."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Prayer and Closing (6:18–24)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c55e195","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Contents.vue
// module id = 72
// module chunks = 0